"use client"

import { useState } from "react"
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import { Box, TextField, Button, Typography, Paper, Alert, CircularProgress, Autocomplete } from "@mui/material"
import BaseURL from "../../api/AppURL";

const Register = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "", // নিশ্চিত পাসওয়ার্ড ফিল্ড যোগ করা হয়েছে
    role: "",
  })
  const [message, setMessage] = useState("")
  const [errors, setErrors] = useState({}) // সার্ভার ভ্যালিডেশন এরর
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const roles = ["admin", "vendor", "user", "mpo", "remanager", "nsmanager", "demouser", "cleanuser"]

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErrors({}) // পূর্ববর্তী এরর মুছে ফেলা
    setMessage("") // পূর্ববর্তী মেসেজ মুছে ফেলা
    setLoading(true)

    try {
      const res = await axios.post(`${BaseURL}/register`, {
        name: form.name,
        email: form.email,
        password: form.password,
        password_confirmation: form.password_confirmation, // নিশ্চিত পাসওয়ার্ড পাঠানো হচ্ছে
        role: form.role,
      })

      // Laravel API থেকে সাধারণত 'message' প্রপার্টিতে সফলতার বার্তা আসে
      setMessage(res.data.message || "Registration successful! Redirecting to login...")
      setTimeout(() => navigate("/login"), 3000) // 3 সেকেন্ড পর লগইন পেজে রিডাইরেক্ট
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        // Laravel validation errors (status 422)
        setErrors(err.response.data.errors)
        let errorMessage = ""
        for (const key in err.response.data.errors) {
          errorMessage += `${err.response.data.errors[key].join(" ")}\n`
        }
        setMessage(`❌ ${errorMessage.trim()}`) // এরর মেসেজ সেট করা
      } else if (err.response && err.response.data && err.response.data.message) {
        // Other API errors with a message
        setMessage(`❌ ${err.response.data.message}`)
      } else {
        // Generic error for network issues or unexpected responses
        setMessage("❌ Registration failed. Please try again.")
      }
      console.error("Registration error:", err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: "100%", borderRadius: 2 }}>
        <Typography variant="h5" component="h1" gutterBottom sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
          Create New Account
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Full Name"
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!errors.name}
            helperText={errors.name ? errors.name[0] : ""}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Email"
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!errors.email}
            helperText={errors.email ? errors.email[0] : ""}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Password"
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!errors.password}
            helperText={errors.password ? errors.password[0] : ""}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Confirm Password"
            type="password"
            name="password_confirmation" // নিশ্চিত পাসওয়ার্ডের জন্য সঠিক নাম
            value={form.password_confirmation}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!errors.password_confirmation}
            helperText={errors.password_confirmation ? errors.password_confirmation[0] : ""}
            sx={{ mb: 3 }}
          />

          {/* Autocomplete for Role */}
          <Autocomplete
            options={roles}
            value={form.role}
            onChange={(e, newValue) =>
              setForm({ ...form, role: newValue || "" })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Role"
                variant="outlined"
                margin="normal"
                required
                error={!!errors.role}
                helperText={errors.role ? errors.role[0] : ""}
              />
            )}
            sx={{ mb: 3 }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mb: 2, py: 1.5 }}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? "Registering..." : "Register"}
          </Button>
          <Box sx={{ textAlign: "center" }}>
            <Link to="/login" style={{ textDecoration: "none" }}>
              <Button variant="text" sx={{ textTransform: "none" }}>
                Already have an account? Login here
              </Button>
            </Link>
          </Box>
          {message && (
            <Alert severity={message.startsWith("❌") ? "error" : "success"} sx={{ mt: 3, whiteSpace: "pre-wrap" }}>
              {message.startsWith("❌") ? message.substring(2) : message}
            </Alert>
          )}
        </form>
      </Paper>
    </Box>
  )
}

export default Register
